module.exports = __webpack_public_path__ + "static/fonts/fa-light-300.bb83110.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.ttf
// module id = lJWQ
// module chunks = 12